// A group on the platform defaults has no list to allow into (D81): make one from its blocked
// domains, then choose it in the group's settings.
import { ListPlus, PencilSimple } from "@phosphor-icons/react";
import { useState } from "react";
import { Link } from "react-router";
import { Button } from "rizzui";

import { useT } from "../i18n";
import { CreateListDrawer } from "./CreateListDrawer";

export function NoListCallout({ groupId, groupName, blocked, owner }: { groupId: string; groupName: string; blocked: string[]; owner: boolean }) {
  const t = useT().network.page;
  const [creating, setCreating] = useState(false);
  return (
    <div className="rounded-xl border border-orange/40 bg-orange-lighter/40 p-4 dark:bg-orange-lighter/10">
      <p className="m-0 font-medium text-gray-900">{t.noList}</p>
      <p className="m-0 mt-1 text-[13px] text-gray-700">{t.noListBody}</p>
      {owner ? (
        <div className="mt-3 flex flex-wrap gap-2">
          <Button className="gap-1.5" onClick={() => setCreating(true)}>
            <ListPlus weight="bold" className="h-4 w-4" /> {t.createWithBlocked}
          </Button>
          <Link to={`/task-groups/${groupId}/edit`} className="inline-flex">
            <Button variant="outline" className="gap-1.5" tabIndex={-1}>
              <PencilSimple weight="bold" className="h-4 w-4" /> {t.editGroup}
            </Button>
          </Link>
        </div>
      ) : null}
      {creating ? <CreateListDrawer open onClose={() => setCreating(false)} initialDomains={blocked} initialName={groupName} /> : null}
    </div>
  );
}
